import { PermissionActionsEnum, PermissionRolesEnum } from "../enums/profiles";
import { PermissionRolesType } from "../types";

const isActionEnabled = (value: unknown): boolean => {
  if (value === true) return true;
  if (value === 1) return true;
  if (typeof value === "string") {
    const normalized = value.trim().toLowerCase();
    return normalized === "1" || normalized === "true";
  }
  return false;
};

export const validationPermission = (
  permissions: PermissionRolesType | null,
  requiredRole: PermissionRolesEnum,
  requiredAction: PermissionActionsEnum
): boolean => {
  if (!permissions) return false;

  const foundRole = permissions[requiredRole];
	if (!foundRole) return false;

	return isActionEnabled((foundRole as any)[requiredAction]);
};
